<template>
  <div>
    <slider-config v-if="config.type === 'slider'" :data.sync="data" :config="config" />
    <number-config v-if="config.type === 'number'" :data.sync="data" :config="config" @validation-changed="onValidationChanged" />
    <!-- <date-time-config
      v-if="config.type === 'date_time'"
      :data.sync="data"
      :config="config"
    /> -->
    <checkbox-config
      v-if="config.type === 'checkbox'"
      :data.sync="data"
      :config="config"
    />
    <select-config v-if="config.type === 'select' || config.type === 'multiple_select'" :data.sync="data" :config="config" />
    <media-config v-if="config.type === 'media'" :data.sync="data" :config="config" @validation-changed="onValidationChanged"/>
    <!-- <more-types /> -->
  </div>
</template>

<script>
import DateTimeConfig from "./DateTimeConfig.vue";
import SliderConfig from "./SliderConfig.vue";
import NumberConfig from "./NumberConfig.vue";
import CheckboxConfig from "./CheckboxConfig.vue";
import SelectConfig from "./SelectConfig.vue";
import MediaConfig from "./MediaConfig.vue";


export default {
  components: {
    SliderConfig,
    NumberConfig,
    DateTimeConfig,
    CheckboxConfig,
    SelectConfig,
    MediaConfig
  },
  props: {
    fieldTypeCfg: Object,
    config: Object,
  },
  data() {
    return {
      data: {},
      isValid: true,
    };
  },
  created() {
    this.data = JSON.parse(JSON.stringify(this.fieldTypeCfg || {}));
  },
  methods: {
    onValidationChanged(isValid) {
      this.isValid = isValid;
      this.$emit("validation-changed", isValid);
    },
    validateNumberConfig() {
      if (this.config.type === 'number') {
        const numberData = this.data.data || {};
        const minValue = numberData.min;
        const maxValue = numberData.max;

        const isMinEmpty = minValue === null || minValue === undefined || minValue === "";
        const isMaxEmpty = maxValue === null || maxValue === undefined || maxValue === "";

        if (isMinEmpty || isMaxEmpty) {
          this.isValid = false;
          this.$emit("validation-changed", false);
          return;
        }

        if (Number(minValue) >= Number(maxValue)) {
          this.isValid = false;
          this.$emit("validation-changed", false);
          return;
        }
      }

      this.isValid = true;
      this.$emit("validation-changed", true);
    }
  },
  watch: {
    data: {
      handler(val) {
        this.$emit("update:data", val);
        this.$nextTick(() => {
          this.validateNumberConfig();
        });
      },
      deep: true,
    },
  },
};
</script>

<style></style>
